module.exports = __webpack_public_path__ + "static/media/4i_website_logo_sup_hkabaeima.55bfed35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4i_website_logo_sup_hkabaeima.jpg
// module id = 62
// module chunks = 0